import { array, boolean, object, string } from 'yup';

import { locationSchema } from '@schemas/locationSchema';
import { userSchema } from '@schemas/userSchema';

// Schema for email invitations (projectMembers)
const projectMemberSchema = object({
  email: string().required(),
  role: string().required(),
});

export const projectFormSchema = object({
  id: string().nullable(),
  uuid: string().nullable(),
  name: string()
    .matches(
      /^$|^[0-9a-zA-Z][^]*$/,
      'Name cannot start with special characters/emoji.'
    )
    .required('Add a project name to continue.'),
  location: locationSchema.nullable(),
  description: string().nullable(),
  teamId: string().required('Team is required'),
  teamUUId: string().nullable(),
  users: array().of(userSchema).ensure(),
  projectMembers: array().of(projectMemberSchema).ensure(),
  color: string().required(),
  icon: string().nullable(),
  currentTeam: object().nullable(),
  files: array().nullable(),
  isOnboardingProject: boolean().optional().default(false),
});
